import classNames from "classnames";
import { ReactNode } from "react";

interface Props {
  htmlFor: HTMLLabelElement["htmlFor"];
  children: ReactNode;
  disabled?: boolean;
}

export default function Label({ children, disabled, htmlFor }: Props) {
  const className = classNames("dark:text-zinc-200", {
    "opacity-50 cursor-default": disabled,
  });

  return (
    <label htmlFor={htmlFor} className={className}>
      {children}
    </label>
  );
}
